const productId = {
	product: {
		title: "Kategori Produk",
		label: "Produk",
		subtitle: "Ringkasan daftar kategori produk",
		empty_state: {
			title: "Tidak ada kategori produk",
			description: "Silakan tambahkan kategori produk baru.",
		},
		table: {
			title: "Data Kategori Produk",
			columns: {
				created_at: "Tanggal dibuat",
				name: "Nama Kategori",
				status: "Status",
			},
		},
		forms: {
			add: {
				button: "Tambah Kategori Produk",
				title: "Tambah Kategori Produk",
				description: "Tambah Kategori Produk baru",
				field: {
					name: {
						label: "Nama Kategori Produk",
						placeholder: "Nama Kategori Produk",
					},
				},
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil membuat kategori produk baru!",
					},
					error: {
						title: "Failed",
						description: "Gagal membuat kategori produk baru!",
					},
				},
			},
			edit: {
				title: "Edit Kategori Produk",
				description: "Edit Kategori Produk",
				info: "Informasi kategori Produk",
				fields: {
					label: "Nama Kategori Produk",
					placeholder: "Nama Kategori Produk",
				},
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil mengubah kategori produk!",
					},
					error: {
						title: "Failed",
						description: "Gagal mengubah kategori produk!",
					},
				},
			},
			delete: {
				title: "Hapus Kategori Produk",
				description: "Apakah anda yakin akan menghapus {name}?",
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil menghapus kategori produk!",
					},
					error: {
						title: "Failed",
						description: "Gagal menghapus kategori produk!",
					},
				},
			},
		},
		actions: {
			save: "Simpan",
			save_changes: "Simpan Perubahan",
			saving_changes: "Menyimpan Perubahan...",
			saving: "Menyimpan...",
			delete: "Hapus",
			deleting: "Menghapus",
			cancel: "Batal",
		},
	},
};

export default productId;
